import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import AlertDialogManager from '@modules/AlertDialogManager';
import DialogManager from '@modules/DialogManager';
import BatchModule from "@modules/BatchModule";


export default function BatchLogDialog() {
  const [open, setOpen] = React.useState(false);

  const dt = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    0
  );
  const defaultDateFrom = dt.getFullYear().toString()
    + '-' + ('00' + (dt.getMonth() + 1).toString()).slice(-2)
    + '-01';
  const defaultDateEnd = dt.getFullYear().toString()
    + '-' + ('00' + (dt.getMonth() + 1).toString()).slice(-2)
    + '-' + ('00' + dt.getDate().toString()).slice(-2);

  const [ batch_name, setBatchName ] = React.useState('');
  const [ dateKeyFrom, setDateKeyFrom ] = React.useState(defaultDateFrom);
  const [ dateKeyTo, setDateKeyTo ] = React.useState(defaultDateEnd);

  DialogManager.init(setOpen, () => {});
  const handleChangeBatchName = (e) => {
    setBatchName(e.target.value);
  };
  const handleChangeDateKeyFrom = (e) => {
    setDateKeyFrom(e.target.value);
  };
  const handleChangeDateKeyEnd = (e) => {
    setDateKeyTo(e.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    if (typeof batch_name === 'string' && batch_name.length === 0) {
      AlertDialogManager.show('ERROR', '「処理名」を入力してください。');
      return;
    }
    BatchModule.insertLog({
      batch_name: batch_name,
      datekey_from: dateKeyFrom,
      datekey_to: dateKeyTo,
    }, (res) => {
      if (res.data.err) {
        AlertDialogManager.show('ERROR', 'DB Error.');
        return 0;
      } else {
        DialogManager.commitFunction({
          id: res.data.batch_id,
          created: new Date().toLocaleDateString('sv-SE'),
          batch_name: batch_name,
          status: 0,
          started: null,
          completed: null
        });
        setOpen(false);
      }
    });
    //
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth
    >
      <DialogTitle id="form-dialog-title">バッチ処理登録</DialogTitle>
      <DialogContent>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            '& > :not(style)': { m: 1, width: '60ch' },
          }}
        >
          <TextField
            id="batch_name"
            label="処理名"
            defaultValue={batch_name}
            value={batch_name}
            onChange={handleChangeBatchName}
            sx={{ margin: 1 }}
          />

          <FormControl component="fieldset">
            <TextField
              id="datekeyfrom"
              label="日付(FROM)"
              type="date"
              defaultValue={dateKeyFrom}
              InputLabelProps={{ shrink: true }}
              onChange={handleChangeDateKeyFrom}
              sx={{ margin: 1 }}
            />
            <TextField
              id="datekeyend"
              label="日付(TO)"
              type="date"
              defaultValue={dateKeyTo}
              InputLabelProps={{ shrink: true }}
              onChange={handleChangeDateKeyEnd}
              sx={{ margin: 1 }}
            />
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          SAVE
        </Button>
      </DialogActions>
    </Dialog>
  );
}